<template>
  <div class="popover-model">
    <a-popover v-model="visible" trigger="click" placement="topLeft" v-if="type==1">
      <div slot="content" class="a-popover-select-user" :style="{width: widthNum+'px'}">
        <div style="text-align: center;">
          <span>加收费用</span>
        </div>
        <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" bordered>
        </a-table>
        <div class="total-money">
          <span>注意：此金额中不含运费</span>
          <span>收款金额：{{ dataDetails.otherExpensesAmount }}</span>
        </div>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <a-popover v-model="visible" trigger="click" placement="topLeft" v-if="type==2">
      <div slot="content" class="a-popover-select-user" :style="{width: widthNum+'px'}">
        <div style="padding-top:10px">
          <span>请在以下账户中输入分配的金额</span>
        </div>
        <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" bordered>
        </a-table>
        <div class="total-money">
          <span>收款金额：{{ dataDetails.paymentAmount }}</span>
        </div>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
    <!-- 更多资源——收货地址 -->
    <a-popover v-model="visible" trigger="click" placement="bottomLeft" v-if="type==3">
      <div slot="content" class="a-popover-add-make">
        <a-row style="margin: 20px 0 10px 0" v-if="dataDetails.contactCustomerAddressName">
          <a-col>
            <span class="label-title">收货地址：</span>
          </a-col>
          <a-col>
            <span>{{ dataDetails.contactCustomerAddressName }}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="label-title">资源列表：</span>
          </a-col>
          <a-col class="resource-list" v-if="dataDetails.attachmentResourceList.length>0">
            <a-row v-for="(item,index) in dataDetails.attachmentResourceList" :key="index">
              <a-col>
                <span class="resource-name-col">{{ item.resourceName }}</span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
      <slot name="trigger-tag"></slot>
    </a-popover>
  </div>
</template>
<script>
import uploadFile from '@/components/upload/uploadFile.vue'
import { getListByStoreId, setAddLogistics, setDeleteLogistics, getCashBankList, financeList, customerList } from '@/utils/api'
export default {
  data () {
    return {
      visible: false,
      columns: [],
      dataSource: [],
    }
  },
  components: {
    uploadFile
  },
  props: {
    widthNum: {
      type: Number,
      default: 416
    },
    heightNum: {
      type: Number,
      default: 320
    },
    type: {
      type: Number,
      default: 1
    },
    dataDetails: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    show () {
      this.visible = true
      this.statusIndex = 0
    },
    init () {
      if (this.type == 1) {
        this.columns = [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 80,
            align: "center",
            customRender: function (t, r, index) {
              if (t.name != 'footer') {
                return parseInt(index) + 1
              } else {
                return ''
              }
            }
          }, {
            title: '费用名称',
            dataIndex: 'otherIncomeExpenditureCategoryName',
          }, {
            title: '金额',
            dataIndex: 'amount'
          }
        ]
      } else if (this.type == 2) {
        this.columns = [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 80,
            align: "center",
            customRender: function (t, r, index) {
              if (t.name != 'footer') {
                return parseInt(index) + 1
              } else {
                return ''
              }
            }
          }, {
            title: '账户名称',
            dataIndex: 'otherIncomeExpenditureCategoryName',
          }, {
            title: '收款金额',
            dataIndex: 'amount'
          }
        ]
      }
    }
  },
  watch: {
    dataDetails () {
      if (this.type == 1) {
        this.dataSource = this.dataDetails.salesPriceOtherExpensesVOList
      } else if (this.type == 2) {
        this.dataSource = this.dataDetails.salesOrderOtherExpensesVOList
      }
    }
  }
}
</script>
<style lang="scss">
.popover-model {
  display: inline-block;
}
.a-popover-select-user {
  padding-bottom: 12px;

  .ant-table-wrapper {
    padding: 16px 0 12px 0 !important;
  }
  .total-money {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
  }
  .ant-table-tbody tr:nth-child(2n) {
    background-color: #ffffff;
  }
}
.a-popover-add-make {
  width: 340px;
  min-height: 100px;
  padding: 0 8px 20px 8px;
  .ant-row {
    display: flex;
    .ant-col {
      height: 36px;
      display: flex;
      align-items: center;
      .label-title {
        display: inline-block;
        font-size: 14px;
        color: #333333;
        padding-right: 16px;
      }
    }
  }
  .resource-list {
    display: flex;
    flex-direction: column;
  }
  .resource-name-col {
    width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #387CFC;
    padding: 5px 0;
  }
}
</style>